import { Badge } from "@/components/ui/badge";
import { formatTRY, catByValue } from "@/lib/api";
import { MapPin, User } from "lucide-react";

export const DayList = ({ jobs }) => {
  if (jobs.length === 0) return <div className="text-center text-slate-400 py-8">Bu güne planlanmış iş yok</div>;
  return (
    <div className="space-y-3">
      {jobs.map((j) => {
        const c = catByValue(j.category);
        return (
          <div key={j.id} className="flex gap-4 p-4 rounded-lg border border-slate-200 bg-white">
            <div className="w-1 rounded-full" style={{ background: c.hex }} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <div className="font-bold text-slate-900">{j.title}</div>
                <Badge variant="outline" style={{ borderColor: c.hex + "50", color: c.hex }}>{c.label}</Badge>
              </div>
              <div className="mt-1 flex items-center gap-4 text-xs text-slate-500 flex-wrap">
                {j.address && <div className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {j.address}</div>}
                {j.employee_name && <div className="flex items-center gap-1"><User className="h-3 w-3" /> {j.employee_name}</div>}
              </div>
            </div>
            <div className="text-right">
              <div className="font-bold text-slate-900">{formatTRY(j.price)}</div>
              <div className="text-xs text-slate-500">Hakediş: {formatTRY(j.employee_payment)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const MiniJobList = ({ jobs }) => {
  if (jobs.length === 0) return <div className="text-xs text-slate-300">-</div>;
  return (
    <div className="space-y-1.5">
      {jobs.map((j) => {
        const c = catByValue(j.category);
        return (
          <div key={j.id} className="p-2 rounded-md text-xs" style={{ background: c.hex + "15", borderLeft: `3px solid ${c.hex}` }}>
            <div className="font-semibold text-slate-800 truncate">{j.title}</div>
            <div className="text-slate-500 truncate">{j.employee_name || "-"}</div>
            <div className="font-bold" style={{ color: c.hex }}>{formatTRY(j.price)}</div>
          </div>
        );
      })}
    </div>
  );
};
